import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-126">
      {label && <label className="block text-sm font-medium mb-1.5" data-id="element-127">{label}</label>}
      <input className={`w-full px-3 py-2 border border-input rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent ${error ? 'border-destructive' : ''} ${className}`} {...props} data-id="element-128" />
      {error && <p className="text-sm text-destructive mt-1" data-id="element-129">{error}</p>}
    </div>;
}
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}
export function Textarea({
  label,
  error,
  className = '',
  ...props
}: TextareaProps) {
  return <div className="w-full" data-id="element-130">
      {label && <label className="block text-sm font-medium mb-1.5" data-id="element-131">{label}</label>}
      <textarea className={`w-full px-3 py-2 border border-input rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent resize-none ${error ? 'border-destructive' : ''} ${className}`} {...props} data-id="element-132" />
      {error && <p className="text-sm text-destructive mt-1" data-id="element-133">{error}</p>}
    </div>;
}